import {useState, useEffect, useRef} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as GoThroughItem from './GoThroughItem';

function App(props) {

  var thisAlertVariant = props.thisAlertVariant;
  var alertPath = props.alertPath;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var upwardInfo = props.upwardInfo;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var itemEdited = props.itemEdited;
  var error = props.error;
  var interactionFn = props.interactionFn;
  var isDraggingDetails = props.isDraggingDetails;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var setItemEdited = props.setItemEdited;
  var getRef1 = props.getRef1;
  var organicChanges = props.organicChanges;
  var otherPeoplesPositions = props.otherPeoplesPositions;
  var dragStart = props.dragStart;
  var dragEnd = props.dragEnd;
  var updatesToPropagate = props.updatesToPropagate;
  var userNos = props.userNos;
  var userID = props.userID;
  var setInputValues = props.setInputValues;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var addWhereText = props.addWhereText;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var onDrag = props.onDrag;
  var refObject = props.refObject;
  var clickEditItem = props.clickEditItem;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var showRelatives = props.showRelatives;
  var doAScreenRef = props.doAScreenRef
  var flashHighlight = props.flashHighlight;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  const [isMouseOver, setMouseIsOver] = useState(false);

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, alertPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function onMouseOverNett(e){
      setMouseIsOver(true);
    }
    function onMouseOutNett(e){
      setMouseIsOver(false);
    }

    var errorString = CoreFns.errorString(error);
    var alertPathString = alertPath.join(' ');
    var alertStyle = StyleFunctions.evaluateStyleR('alert', thisAlertVariant.s, alertPath.concat(['s']), currentList, internalVariables, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
    if (!showRelatives){
      alertStyle.visibility = 'hidden';
    }

    StyleFunctions.modStyleWithFlashHighlight(alertStyle, flashHighlight, alertPathString);

    var isThisPanelEdited = false;
    var addText = '';
    if (alertStyle.buttonColor){
      var outline = alertStyle.buttonOutline;
      if (outline){
        outline = 'outline-';
      }else{
        outline = '';
      }
      addText = ' btn-'+ outline + alertStyle.buttonColor;
    }
    var className1 = 'alert' + addText;

    if (itemEdited && (itemEdited.t === 'alert') && (itemEdited.path.join(' ') === alertPathString)){
      isThisPanelEdited = true;
      className1 += ' editing';
    }else if (errorString){
      if (errorString.indexOf(alertPathString) === 0){
        className1 += ' editingError';
      }
    }

    var alertPieces;
    var alertItems = thisAlertVariant.k;

    if (alertItems){

      var alertItemsSet = GoThroughItem.goThroughItems(alertItems, chains, false, alertPath, interactionFn, itemEdited, setItemEdited, isDraggingDetails, insetWidth, insetHeight, dragStart, dragEnd, onDrag, isShowingSomeDropDown, currentList, otherPeoplesPositions, updatesToPropagate, organicChanges, userNos, userID, getRef1, refObject, error, internalVariables, clickEditItem, onClickItemChangeSelection, inputValues, setInputValues, ownVariables, urlParamsForExecution, urlHeader, setIsShowingSomeDropDown, setIsClickingOnContentDiv, upwardInfo, isClickingOnContentDiv, addWhereText, potentiallyAddWhichItem, hoveringWhere, actHoveringWhere, screenSelectionChoices, setScreenSelectionChoices, popUps, setPopUps, true, doAScreenRef, flashHighlight, lastEdited, counter);
      alertPieces = alertItemsSet.expressedItems;
      if (alertPieces.length === 0){
        var m1 = 'Empty Banner. Click to Edit.';
        if (isThisPanelEdited){
          m1 = 'Empty Banner. Use the "Add Items" tab to add items.';
        }
        alertPieces = <div style={{padding:'5px', textAlign:'center', color:'#A2A2A2'}}>{m1}</div>
//          
      }
    }else{
      alertPieces = <div style={{padding:'5px', textAlign:'center', color:'#A2A2A2'}}>Need to redo this alert.</div>
    }
//    
    if (isMouseOver && alertStyle.hoverColor){
      alertStyle.backgroundColor = alertStyle.hoverColor;
    }


//

    function clickAlert(e){
      if (!interactionFn){
        setItemEdited({t:'alert', path:alertPath})
        e.stopPropagation();        
      }else{
        interactionFn(e, thisAlertVariant.oc, 'click', upwardInfo, alertPath.concat(['oc', 'click']));
      }
    }

  var overallDraggable = false;
  if (isThisPanelEdited){
    overallDraggable = true;
    alertStyle.pointer = 'move';
  }


  function oDragStart(e){
    itemEdited.d = true;
    setItemEdited({...itemEdited})
  }

  function oDragEnd(e){
    delete itemEdited.d;
    setItemEdited({...itemEdited})
  }
  
  return <div ref={ref1} className={className1} style={alertStyle} onClick={clickAlert} onMouseOver={onMouseOverNett} onMouseOut={onMouseOutNett} draggable={overallDraggable} onDragStart={oDragStart} onDragEnd={oDragEnd} >{alertPieces}</div>

}

export default App;
